// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum Visibility {
  Visible = 0,
  Hidden = 1,
  Collapsed = 2,
}
